import { IFileToUpload } from "../../../../../interfaces/IFileToUpload";
import { IOfficeFileDto } from "../../../../../interfaces/IOfficeFileDto";
import { IOutlookRestDto } from "../../../../../interfaces/IOutlookRestDto";

export interface PIIRequest {
    accessToken: string;
    siteUrl?: string;
    fileUrl?: string;
    fileData?: string;
    forceRecheck?: boolean;
    redactPiiData?: boolean;
}

export interface PIIResult {
    piiDetected?: boolean;
    pii?: string;
    piiError?: string;
    isChecking?: boolean;
    rawPII?: string[];
}

export interface GraphItemPIIRequest {
    accessToken: string;
    driveId?: string;
    itemId?: string;
    fileName?: string;
    redactPiiData?: boolean;
}

export interface ApprovalRequest {
    hookId: number;
    hookTypeId: number;
    hookName: string;
    tenantGuid: string;
    requestor: string;
    approvers: string[];
    dueDate?: Date;
    details: string;
    itemLinks: ItemLink[];
}

export interface ItemLink {
    name: string;
    sharingUrl?: string;
    fullWebUrl?: string;
    uniqueId: string;
    siteUrl: string;
    listId: string;
    listName?: string;
    serverRelativeUrl?: string;
    itemId?: string;
}

export interface ApprovalExecutionResult {
    success: boolean;
    errorMessage: string;
    statusCode: number;
    failedFileNames: string[];
}

export interface SignRequest {
    hookId: number;
    hookName: string;
    tenantGuid: string;
    accessToken: string;
    requestor: string;
    recipients: SignRequestRecipient[];
    message: string;
    documents: ItemLink[];
}

export interface SignRequestRecipient {
    firstName: string;
    lastName: string;
    email: string;
}


export interface SignRequestResult {
    packageId: string;
    designerUrl: string;
}

export interface FilePreCommitRequest {
    accessToken: string;
    siteUrl: string;
    destinationUrl: string;
    fileName: string;
    autoFolderCreation: boolean;
    ignoreSameUserLock?: boolean;
}

export interface FolderPreCommitRequest {
    accessToken: string;
    siteUrl: string;
    destinationUrl: string;
    folderName: string;
}

export interface FilePreCommitResult {
    exists: boolean;
    checkedOut: boolean;
    checkedOutBy: string;
    locked: boolean;
    lockedBy: string;
}

export enum HookType {
    All = -1,
    AllApproval = 0,
    Approval = 1,
    Sign = 2,
    BatchApproval = 3,
    Generic = 4
}

export interface IHookRequest {
    TenantGUID: string,
    HookTypeId: HookType
}

export interface IHookResult {
    id: number;
    typeId: number;
    name: string;
    description: string;
    sites: string[];
    libraries: string[];
    dueDateDays?: number;
    isPeoplePickerRequired?: boolean;
    peoplePickerTitle?: string;
}

export interface IFileSaveResult {
    success: boolean,
    message: string,
    succeededFiles: IFileSaveFileItem[],
    failedFileNames: string[]
}

export interface IFileSaveFileItem {
    name: string,
    uniqueId: string
}

interface BaseMetadataUpdateRequest {
    accessToken: string;
    siteUrl: string;
    listId: string;
    isFolder: boolean;
    isListItem: boolean;
    listSettings: ListSettings;
    metadata: MetadataDto[];
}

export interface MetadataUpdateRequest extends BaseMetadataUpdateRequest {
    listItemUniqueId: string;
}

export interface BulkMetadataUpdateRequest extends BaseMetadataUpdateRequest {
    listItemUniqueIds: string[];
}

export interface ReplaceFileRequest {
    accessToken: string;
    accountId: string;
    siteUrl: string;
    listId: string;
    fileUniqueId: string;
    fileName?: string;
    checkinType: CheckinTypes;
    metadata: MetadataDto[];
    outlookRestInfo?: IOutlookRestDto;
    emailItemId?: string;
    attachmentFile?: IFileToUpload;
    officeFile?: IOfficeFileDto;
}

export interface CreateDocumentFromTemplateRequest {
    destAccessToken: string;
    templateAccessToken: string;
    tenantGuid: string;
    destSiteUrl: string;
    destListId: string;
    destFolderUniqueId: string;
    templateSiteUrl: string;
    templateUniqueId: string;
    teamId: string;
    channelId: string;
    fileName: string;
    checkinType: CheckinTypes;
    metadata: MetadataDto[];
}

export interface ReplaceFileRequest {
    accessToken: string;
    accountId: string;
    siteUrl: string;
    listId: string;
    fileUniqueId: string;
    fileName?: string;
    checkinType: CheckinTypes;
    metadata: MetadataDto[];
    outlookRestInfo?: IOutlookRestDto;
    emailItemId?: string;
    attachmentFile?: IFileToUpload;
    officeFile?: IOfficeFileDto;
}

export interface ConvertAndSaveAsPDFRequest {
    graphToken: string;
    sharePointToken: string;
    driveId: string;
    itemId: string;
    siteUrl: string;
    listId: string;
    fileUniqueId: string;
    EnsureUniqueFilename: boolean;
    checkinType?: CheckinTypes;
}

export interface MetadataDto {
    type: string;
    internalName: string;
    displayName?: string;
    value: any;
}

export interface ListSettings {
    enableMinorVersions: boolean;
}

export interface ISharePointToEmailMapping {
    columnName: string;
    emailProperty: string;
}

export interface ExchangeMailFolderUploadRequest {
    sharePointToken: string;
    mailToken: string;
    siteUrl: string;
    listId: string;
    destinationUrl: string;
    autoFolderCreation: boolean;
    exchangeAccountEmail: string;
    mailItemCategory: string;
    mailFolderId: string;
    metadata: MetadataDto[];
    sharePointEmailMappings?: ISharePointToEmailMapping[];
    folderName?: string
}

export interface BackgroundTaskProgress {
    taskId: string;
    number: string;
    message: string;
    logs: string[];
}

export enum CheckinTypes {
    minorCheckIn = 0,
    majorCheckIn = 1,
    overwriteCheckIn = 2
}